import { PFile } from 'plant-common/src/models/pFile';
import Vue from 'vue';

export function createHtmlFileSaver(vueModel) {
	return new Vue({
		data() {
			return {
				vueModel
			};
		},
		computed: {
			page() {
				return this.vueModel.value.body.contents.page;
			}
		},
		methods: {
			async saveTextAsFile(triggerPage, contentHTML) {
				const blob = new Blob([contentHTML], { type: 'plain/text' });

				const myFile = new File([blob], triggerPage.id + '.html', { type: blob.type });
				const myPFile = new PFile(myFile);
				await myPFile.upload();

				triggerPage.html = myPFile;
				this.page.html = myPFile;
			}
		}
	});
}
